
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFuse01On as ObiFuse01OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fuse-01-on.js';
 
 
 

 
 export const ObiFuse01On = createComponent({
   react: React,
   tagName: 'obi-fuse-01-on',
   elementClass: ObiFuse01OnElement,
   events: {
     
   }
  });
 
 